import React, {useEffect, useState} from 'react';
import {Center, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text} from "@chakra-ui/react";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";
import {formatAccount} from "../../features/ValueFormater";

function InitiatePopup({isOpen, setIsOpen, message, account1Value, account2Value, InitiateTransferDate}) {
    const [open, setOpen] = useState(false);

    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);


    const handleConfirmInitiateTransfer = () => {
        dispatch(setActionType(ACTION_TYPES.CONFIRM_INITIATE_TRANSFER));
        dispatch(setActionPayload({
            InitiateTransferDate
        }))
        setIsOpen(false);

        onOpenQrAfterGenerate();
    }
    return (
        <Modal isCentered isOpen={open} onClose={() => {
            setIsOpen(false);
        }
        }>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader textAlign='center' textTransform='uppercase'>
                    <div className="modal-header-image">
                        {<img src="Images/caution.png" alt=""/>}
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Center>
                        <Text textAlign='center' fontSize={16} fontWeight={700}>
                            Close Balance
                        </Text>
                    </Center>
                    <Center>
                        <Text textAlign='center'>
                            {message}
                        </Text>
                    </Center>
                    <div className="modalAccountValues">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-4">From Account</div>
                            <div className="col-6 account-value">{formatAccount(account1Value?.Balance, account1Value?.CurrencyID)}</div>
                        </div>
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-4">From Account</div>
                            <div className="col-6 account-value">{formatAccount(account2Value?.Balance, account2Value?.CurrencyID)}</div>
                        </div>
                    </div>
                    <Center>
                        <button
                            id="closeTransferModalBtn"
                            onClick={() => {
                                setIsOpen(false);
                            }}
                        >
                            Not Now
                        </button>
                        <button
                            id="closeModalBtn"
                            onClick={() => {
                                handleConfirmInitiateTransfer()
                            }}
                        >
                            Confirm Transfer
                        </button>
                    </Center>

                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default InitiatePopup;